var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiffrenceVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09472 3.28417H1.25111C1.85321 3.28417 2.34583 3.77679 2.34583 4.37889V9.8525C2.34583 10.4546 1.85321 10.9472 1.25111 10.9472H1.09472C0.492625 10.9472 0 10.4546 0 9.8525V4.37889C0 3.77679 0.492625 3.28417 1.09472 3.28417ZM5.47361 0C6.07571 0 6.56833 0.492625 6.56833 1.09472V9.8525C6.56833 10.4546 6.07571 10.9472 5.47361 10.9472C4.87151 10.9472 4.37889 10.4546 4.37889 9.8525V1.09472C4.37889 0.492625 4.87151 0 5.47361 0ZM9.8525 6.25556C10.4546 6.25556 10.9472 6.74818 10.9472 7.35028V9.8525C10.9472 10.4546 10.4546 10.9472 9.8525 10.9472C9.2504 10.9472 8.75778 10.4546 8.75778 9.8525V7.35028C8.75778 6.74818 9.2504 6.25556 9.8525 6.25556Z",
    fill: "#FF1028"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiffrenceVector);
export default __webpack_public_path__ + "static/media/diffrence_vector.a295b7b1530ca67eae02afcda4099879.svg";
export { ForwardRef as ReactComponent };